<template>
    <div class="w-full space-y-3">
        <Head title="Queue History"/>
        <div class="flex justify-between">
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">Queue History</h1>
        </div>
    </div>
    <div class="mt-5 bg-white py-6 px-4 sm:p-6 shadow mb-6 flex justify-center">
        <ul role="list" class="space-y-6 w-2/3">
            <template v-for="(queue, index) in queues" :key="index">
                <hr v-if="index > 0" />
                <li class="relative flex gap-x-4">
                    <div class="-bottom-6 absolute left-0 top-0 flex w-6 justify-center">
                        <div class="w-px bg-gray-200" />
                    </div>
                    <div class="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                        <span v-if="queue.switched_off_user">
                            <LockClosedIcon class="h-6 text-green-500" aria-hidden="true" />
                        </span>
                        <span v-else>
                            <ExclamationIcon class="h-6 text-yellow-500" aria-hidden="true" />
                        </span>
                    </div>
                    <p class="flex-auto py-0.5 text-sm leading-5 text-gray-900">
                        <span v-if="queue.switched_off_user">
                            <span class="font-medium">{{ queue.switched_off_user.first_name }} {{ queue.switched_off_user.last_name }}</span> turned <strong>on</strong> the automatic Unit 4 Sync, therefore <strong>closing</strong> the queue ({{ moment(queue.switched_off, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY [at] HH:mm') }}).
                        </span>
                        <span v-else>
                            <span class="font-bold uppercase">The unit 4 automatic sync is off, meaning the queue is currently open.</span>
                        </span>
                    </p>
                </li>
                <li class="relative flex gap-x-4">
                    <div class="-bottom-6 absolute left-0 top-0 flex w-6 justify-center">
                        <div class="w-px bg-gray-200" />
                    </div>
                    <div class="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                        <ClipboardListIcon class="h-6 w-6 text-pitch-purple" aria-hidden="true" />
                    </div>
                    <div class="flex-auto rounded-md p-3 ring-1 ring-inset ring-gray-200">
                        <div class="flex justify-between gap-x-4">
                            <div class="py-0.5 text-sm leading-5 text-gray-500">
                                <span v-if="queue.invoices.length > 0">
                                    <span class="font-medium text-gray-900">Invoices held within the queue:</span>
                                </span>
                                <span v-else>
                                    <span class="font-medium text-gray-900">No invoices were held within this queue.</span>
                                </span>
                            </div>
                        </div>
                        <ul class="ml-5 mt-1 list-disc">
                            <span v-if="queue.invoices">
                                <template v-for="invoice in queue.invoices">
                                    <li class="text-sm leading-6 text-gray-900">{{ invoice.invoiceable.reference }}</li>
                                </template>
                            </span>
                        </ul>
                    </div>
                </li>
                <li class="relative flex gap-x-4">
                    <div class="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                        <LockOpenIcon class="h-6 text-red-500" aria-hidden="true" />
                    </div>
                    <p class="flex-auto py-0.5 text-sm leading-5 text-gray-900">
                        <span class="font-medium">{{ queue.switched_on_user.first_name }} {{ queue.switched_on_user.last_name }}</span> turned <strong>off</strong> the automatic Unit 4 Sync, therefore <strong>opening</strong> the queue ({{ moment(queue.switched_on, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY [at] HH:mm') }}).
                    </p>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
    import moment from "moment";
    import Authenticated from "@/Layouts/Authenticated";
    import {Link, Head, usePage, useForm} from "@inertiajs/vue3";
    import { ClipboardListIcon, LockOpenIcon, LockClosedIcon, ExclamationIcon } from '@heroicons/vue/solid'

    export default {
        layout: Authenticated,
        components: {
            Head,
            Link,
            LockOpenIcon,
            LockClosedIcon,
            ExclamationIcon,
            ClipboardListIcon
        },
        props: ['queues'],
        data() {
            return {
            }
        },
        created() {
            this.moment = moment
        }
    }
</script>
